import React, { Component } from 'react';
import { string, bool, func } from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { questionsPropTypes } from 'types/accountTypes';

import { actionCreators as accountActions } from '../../../../../../../../../redux/accountHandlers';

import QuestionMapper from './questionMapper';
import AccountRelationshipValidation from './layout';
import styles from './styles';

class AccountRelationshipValidationContainer extends Component {
  componentWillMount = () => this.props.dispatch(accountActions.getQuestions(this.props.initialAccount));

  componentWillReceiveProps(nextProps) {
    if (
      this.props.questionsLoading &&
      !nextProps.questionsLoading &&
      nextProps.questions &&
      nextProps.questions.length === 0
    ) {
      this.props.onCloseModal();
    }
  }

  render() {
    return (
      <div style={styles.container}>
        <AccountRelationshipValidation
          onSubmit={this.props.onSubmit}
          questions={this.props.questions}
          loading={this.props.questionsLoading || this.props.addAccountLoading}
        />
      </div>
    );
  }
}

AccountRelationshipValidationContainer.propTypes = {
  onSubmit: func.isRequired,
  onCloseModal: func.isRequired,
  questions: questionsPropTypes,
  questionsLoading: bool.isRequired,
  addAccountLoading: bool.isRequired,
  initialAccount: string.isRequired
};

export const questionSelector = createSelector(
  store => store.account.questions,
  questions => questions.map((question, index) => QuestionMapper(question, index))
);

const mapStateToProps = store => ({
  questions: questionSelector(store),
  questionsLoading: store.account.questionsLoading,
  addAccountLoading: store.account.addAccountLoading,
  initialAccount: store.account.addAccountFlow.initialAccount
});

export default connect(mapStateToProps)(AccountRelationshipValidationContainer);
